import { makeStyles,useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles(theme =>({
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    overflow: 'hidden',
  },
  table: {
    width: '100%',
    [theme.breakpoints.down('sm')]:{
      overflowX: 'auto',
      behavior: 'smooth' ,
      display: 'block',
      width: '100%',
    }
  },
  heading: {
    color: '#071B27',
    fontWeight: 'bold',
    textTransform: 'uppercase'
  },
  imageWrapper: {
    width: 60,
    height: 36
  },
  image: {
    width: '100%',
    height: '100%',
    border: '1px solid rgba(0, 0, 0, 0.22)',
    boxSizing: 'border-box',
    borderRadius: 3
  },
  tableCell: {
    fontSize: '13px',
    border: 'none',
    padding: '5px 0',
    color: '#071B27'
  },
  headTableCell: {
    paddingBottom: '15px',
    paddingTop: 0
  },
  imgCell: {
    width: 60,
    paddingLeft: 10
  },
  nameCell: {
    width: 237,
    paddingLeft: 24
  },
  availabilityCell: {
    width: 153,
    paddingLeft: 15,
    color: '#99ADBD'
  },
  scheduleCell: {
    width: 237,
    paddingLeft: 15
  },
  productCodeCell: {
    width: 153,
    paddingLeft: 15
  },
  guestsCell: {
    width: 118,
    paddingLeft: 15
  },
  iconButton: {
    padding: '0px 0px 0px 24px',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  tableHead: {
    padding: 18
  },
  tableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#E2F5F8'
    }
  }
}));

export default useStyles;
